(function () {
  const video = document.querySelector('.lo-gift video')
  if (!video) return
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    video.removeAttribute('autoplay')
    video.pause()
    return
  }
  if (!('IntersectionObserver' in window)) return
  new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          const playing = video.play()
          if (playing && playing.catch) {
            playing.catch(function () {})
          }
        } else {
          video.pause()
        }
      })
    },
    { threshold: 0.2 }
  ).observe(video)
})()
